"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setHttpVariableValue = exports.setComputationVariableValue = exports.setQuestionVariableValue = void 0;
const messages_1 = require("../../services/messages");
const setQuestionVariableValue = (state, { varIndexOrId, value }) => {
    const questionVariables = state.value.variables.questionVariables;
    const index = typeof varIndexOrId === "string"
        ? questionVariables.findIndex((variable) => variable.id === varIndexOrId)
        : varIndexOrId;
    const variable = state.value.variables.questionVariables[index];
    variable.value = value.toString();
    (0, messages_1.sendNewVariableMessage)({ name: variable.name, value: value.toString() });
    const variablesWithSameName = questionVariables.filter((v) => v.name === variable.name && v.id !== variable.id);
    variablesWithSameName.forEach((v) => (v.value = value.toString()));
};
exports.setQuestionVariableValue = setQuestionVariableValue;
const setComputationVariableValue = (state, payload) => {
    const computationVariables = state.value.variables.computationVariables;
    const index = computationVariables.findIndex((variable) => variable.id === payload.variableId);
    if (index === -1)
        return;
    (0, messages_1.sendNewVariableMessage)({
        name: computationVariables[index].name,
        value: payload.value.toString(),
    });
    computationVariables[index].value = payload.value.toString();
};
exports.setComputationVariableValue = setComputationVariableValue;
const setHttpVariableValue = (state, payload) => {
    const httpVariables = state.value.variables.httpRequestVariables;
    if (!httpVariables)
        return;
    const index = httpVariables.findIndex((variable) => variable.id === payload.variableId);
    if (index === -1)
        return;
    (0, messages_1.sendNewVariableMessage)({
        name: httpVariables[index].name,
        value: payload.value.toString(),
    });
    httpVariables[index].value = payload.value.toString();
};
exports.setHttpVariableValue = setHttpVariableValue;
//# sourceMappingURL=chatbot.js.map